import { render, staticRenderFns } from "./CorrectScoreCard.vue?vue&type=template&id=7f4fb300&scoped=true&"
import script from "./CorrectScoreCard.vue?vue&type=script&lang=js&"
export * from "./CorrectScoreCard.vue?vue&type=script&lang=js&"
import style0 from "./CorrectScoreCard.vue?vue&type=style&index=0&id=7f4fb300&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4fb300",
  null
  
)

export default component.exports